/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MaritalStatus = {
  type: 'Enum',
} as const;
